import { createSlice } from "@reduxjs/toolkit";
import { LOCAL_STORAGE_KEYS } from "utils/localStorageKeys";

const initialState = {
  isUserLoggedIn: JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEYS?.KEEP_ME_LOGGED_IN)
  ),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginUser: (state, action) => {
      state.isUserLoggedIn = true;
      localStorage.setItem(
        LOCAL_STORAGE_KEYS?.KEEP_ME_LOGGED_IN,
        state.isUserLoggedIn
      );
    },
    logoutUser: (state, action) => {
      state.isUserLoggedIn = false;
      localStorage.setItem(
        LOCAL_STORAGE_KEYS?.KEEP_ME_LOGGED_IN,
        state.isUserLoggedIn
      );
    },
  },
});

export const { loginUser, logoutUser } = authSlice.actions;

export default authSlice.reducer;
